import React, { Component } from "react";
import { Container, Spinner, Row, Col, CardGroup, Card, CardBody, CardFooter, Form, UncontrolledTooltip, Button, InputGroup, Jumbotron, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import Proptypes from "prop-types";
import { NotificationManager } from "react-notifications";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import $ from "jquery";
import { getLoginSettings } from "../../actions/actionLogin";
import {createAccount} from "../../actions/actionCreateAccount";
import { required, renderField, email } from "../../utils/formValidations.js";
import "../../../assets/style/style.css";
import ReCAPTCHA from "react-google-recaptcha";
import {getSignOnURL} from "../../actions/actionSaml";
import LoadingSpinner from "../../components/LoadingSpinner";

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recaptcha_needed: true,
            recaptcha_value: null,
            google_recaptcha_site_key: "6Le5qy4UAAAAAGSsuiAYVhAm4b_YlKFTIeTgch2e",
            error: true,
            loginBoxClass: "",
            loginClicked: false,
            authModal: false,
            brandingSet: false,
            loginData: {}
        };
        this.handleCreate = this.handleCreate.bind(this);
        this.signupError = this.signupError.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleSuccess = this.handleSuccess.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
        this.onCaptchaChange = this.onCaptchaChange.bind(this);
        this.singleSignOn = this.singleSignOn.bind(this);
        this.handleSSOSuccess = this.handleSSOSuccess.bind(this);
        this.handleSSOError = this.handleSSOError.bind(this);
    }
    onCaptchaChange(value){
        this.setState({recaptcha_value: value});
    }

    handleCreate({ username, password, password_confirm }) {
        //TODO verify password are the same
        //trim passwords
        if (password != password_confirm){
            this.signupError("The passwords do not match.")
        }
        else if (!this.state.recaptcha_value){
            this.signupError("Please solve the reCAPTCHA.")
        }
        else {
            let login_data = {
                "emailaddress": username.trim().toLowerCase(),
                "password": password.trim(),
                "recaptcha": this.state.recaptcha_value
            };
            this.setState({loginBoxClass: "", error:true, loginClicked: true, loginData: login_data});
            this.props.createAccount(login_data).
                then(() => this.handleSuccess(login_data)).
                catch(() => this.signupError());
        }
    }

    signupError(error) {
        if (error || this.props.createAccountError) {
            this.setState({loginBoxClass: "login_error", error:false, loginClicked: false});
            NotificationManager.error(error || this.props.createAccountError,"Create Account Failed", 5000);
        }
    }



    handleSuccess() {
        if (this.props.createAccountError) {
            this.setState({loginBoxClass: "login_error", error:false, loginClicked: false});
            NotificationManager.error(this.props.createAccountError,"Create Account Failed", 5000);
        }
        else{
           this.toggle();
        }


    }

    handleComplete(){
         window.location.href = "/#/";
    }


    toggle(){
        if (this.state.authModal){
            // The modal is being closed. Push the user to the login page
            this.handleComplete()
        }
        else{
           this.setState({authModal: !this.state.authModal, loginClicked: false});
        }
    }

    singleSignOn(ssoType, id){
        window.localStorage.setItem(ssoType, id);
        if (typeof this.props.location.state !== 'undefined') {
            window.localStorage.setItem("continuation_url", "/#" + this.props.location.state.from.pathname + this.props.location.state.from.search);
        }
        this.props.getsso(ssoType, id)
            .then(() => this.handleSSOSuccess())
            .catch(() => this.handleSSOError());
    }
    handleSSOSuccess() {
        const {sso_url, sso_error_message, sso_error} = this.props;
        if (sso_error_message) {
            NotificationManager.error(sso_error_message,"Saml Login Failed", 5000);
        } else {
            if (sso_url) {
                window.location.href = sso_url;
            } else {
                NotificationManager.error("Contact Administrator","Saml Login Failed", 5000);
            }
        }
    }

    handleSSOError(){
        const {sso_error} = this.props;
        if (sso_error)
            NotificationManager.error("Contact Administrator","Saml Login Failed", 5000);
    }


    async componentDidMount() {
        const { response: settings } = await this.props.getLoginSettings();
        window.localStorage.setItem("login_logo", settings.login_logo);
        window.localStorage.setItem("login_caption", settings.login_caption);
        window.localStorage.setItem("header_logo", settings.header_logo);
        window.localStorage.setItem("login_splash_background", settings.login_splash_background);
        window.localStorage.setItem("splash_background", settings.splash_background);
        window.localStorage.setItem("html_title", settings.html_title);
        window.localStorage.setItem("favicon_logo", settings.favicon_logo);
        window.localStorage.setItem("loading_session_text", settings.loading_session_text);
        window.localStorage.setItem("joining_session_text", settings.joining_session_text);
        window.localStorage.setItem("destroying_session_text", settings.destroying_session_text);
        window.localStorage.setItem("launcher_background_url", settings.launcher_background_url);
        this.setState({brandingSet: true})

        if (window.localStorage.getItem("user_info") == null) {
            $("body").addClass("login-body");
        }  else {
            $("body").removeClass("login-body");
        }
    }

    componentWillUnmount() {
        $("body").removeClass("login-body");
    }

    render() {
        if (this.props.getSsoLoading){
            return (<div> <LoadingSpinner /></div>);
        }
        const {login_settings, handleSubmit } = this.props;

        let login_splash_background = window.localStorage.getItem('login_splash_background');
        let login_logo = window.localStorage.getItem('login_logo');
        login_logo = login_logo ? login_logo : '/img/logo.svg';
        let powered_by = login_logo != "/img/logo.svg";

        let login_caption = window.localStorage.getItem('login_caption');
        login_caption = login_caption ? login_caption : 'The Container Streaming Platform';


        let elem = document.getElementById("favicon");
        let favicon_logo = window.localStorage.getItem('favicon_logo');
        if (favicon_logo != undefined){
            elem.href=favicon_logo;
        }

        let html_title = window.localStorage.getItem('html_title');
        if (html_title != undefined){
             document.title=html_title;
        }

        const saml_logins = _.map(this.props.saml_configs, config =>
            <div key={config.saml_id} displayName={config.display_name}>
                <div  className="sso-login-option">
                    <Button
                        className="px-4 mb-2 sso-login-button"
                        onClick={(id) => this.singleSignOn("saml_id", config.saml_id)}
                        type="submit">

                        <span className="sso-login-logo">
                            { config.logo_url ?
                                <img src={config.logo_url} alt="sso-logo"/>
                            :
                                <span className="sso-login-lock">
                                    <i id="login_assistance_tip" className="fa fa-lock" />
                                </span>

                            }
                        </span>
                        <span className="sso-login-name">
                            {config.display_name}
                        </span>
                    </Button>
                </div>
            </div>
        );

        const oidc_logins = _.map(this.props.oidc_configs, config =>
            <div key={config.oidc_id} displayName={config.display_name}>
                <div  className="sso-login-option">
                    <Button
                        className="px-4 mb-2 sso-login-button"
                        onClick={(id) => this.singleSignOn("oidc_id", config.oidc_id)}
                        type="submit">

                        <span className="sso-login-logo">
                            <span className="sso-login-logo">
                                { config.logo_url ?
                                    <img src={config.logo_url} alt="sso-logo"/>
                                :
                                    <span className="sso-login-lock">
                                        <i id="login_assistance_tip" className="fa fa-lock" />
                                    </span>

                                }
                            </span>
                        </span>
                        <span className="sso-login-name">
                            {config.display_name}
                        </span>
                    </Button>
                </div>
            </div>

        );

        let sso_logins = saml_logins
        sso_logins.push(...oidc_logins);
        sso_logins.sort((a, b) => (a.props.displayName.toLowerCase() > b.props.displayName.toLowerCase()) ? 1 : -1)


        return (
            <div >
                <div className="login_box" style={{backgroundImage: 'url("' + login_splash_background + '")'}}>
                    <div className={"login-flex " + this.state.loginBoxClass}>
                        <CardGroup className="mb-0">
                            <Card className="login-card">
                                <CardBody className="card-body col-md-offset-3 ">
                                    <div className="login-card-top">
                                    <h1 className="login-title"><strong>Create Account</strong> </h1>
                                        <Form onSubmit={handleSubmit(this.handleCreate)}>
                                        <InputGroup className="mb-3 login_form_field">
                                            <div className="input-group-prepend">
                                                <span className={`input-group-text`}>
                                                    <i className="fa fa-envelope-o" aria-hidden="true"></i>
                                                </span>
                                            </div>
                                            <Field
                                                name="username"
                                                placeholder="Your Email"
                                                component={renderField}
                                                type="text"
                                                validate={email}
                                            />
                                        </InputGroup>
                                        <InputGroup className="mb-4 login_form_field">
                                            <div className="input-group-prepend">
                                                <span className={`input-group-text`}>
                                                    <i className="icon-lock"></i>
                                                </span>
                                            </div>
                                            <Field
                                                name="password"
                                                placeholder="Your Password"
                                                component={renderField}
                                                type="password"
                                                validate={required}
                                            />
                                        </InputGroup>
                                            <InputGroup className="mb-4 login_form_field">
                                            <div className="input-group-prepend">
                                                <span className={`input-group-text`}>
                                                    <i className="icon-lock"></i>
                                                </span>
                                            </div>
                                            <Field
                                                name="password_confirm"
                                                placeholder="Confirm Your Password"
                                                component={renderField}
                                                type="password"
                                                validate={required}
                                            />
                                        </InputGroup>
                                            {this.state.recaptcha_needed ?
                                                <Row>
                                                    <div style={{
                                                        paddingTop: "20px",
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        paddingBottom: "20px"
                                                    }}>
                                                        {this.state.google_recaptcha_site_key ?
                                                            <ReCAPTCHA
                                                                sitekey={this.state.google_recaptcha_site_key}
                                                                onChange={this.onCaptchaChange}
                                                            />
                                                            : ""
                                                        }
                                                    </div>
                                                </Row>
                                                :
                                                ""
                                            }
                                        <Row>
                                            <Col xs="12">
                                                <div className="text-right">  {this.state.loginClicked ? <Spinner color="primary" className="login-spinner" /> : <Button color="primary" className="login-card-btn"  type="submit">Submit</Button>} </div>
                                            </Col>
                                        </Row>

                                    </Form>
                                    </div>

                                     {login_settings  && login_settings.sso_enabled && sso_logins && sso_logins.length > 0 &&

                                            <div className="sso-login-options">
                                                {sso_logins}
                                            </div>
                                     }
   
                                </CardBody>

                                {this.props.login_settings && this.props.login_settings.notice_message && this.props.login_settings.notice_title &&
                                        <div className="notice-box">
                                                <h4>{this.props.login_settings && this.props.login_settings.notice_title}</h4>
                                                <p>{this.props.login_settings && this.props.login_settings.notice_message}</p>
                                        </div>
                                        }
                            </Card>
                            <Card className="text-white logo-card   d-md-down-none">
                                <div className="logo-wrapper">
                                    <div className="logo-center">
                                    <img src={login_logo} alt="logo"/>
                                        <CardBody className="text-center">
                                            {powered_by ?
                                            <div className="logo-bottom-txt">
                                                <p>Powered by Kasm Workspaces</p>
                                            </div>
                                            :
                                            ""}
                                            <div className = "logo-bottom-txt">
                                                <h5>{login_caption}</h5>
                                            </div>
                                        </CardBody>
                                    </div>
                                </div>
                            </Card>
                        </CardGroup>
                        <Modal isOpen={this.state.authModal}  toggle={this.toggle} centered={true} className="user-modal confirm-modal">
                            <Form onSubmit={handleSubmit(this.toggle)}>
                                <ModalHeader toggle={this.toggle}>Success</ModalHeader>
                                <ModalBody className="confirm-modal-body">
                                    Please check your email for the confirmation link
                                </ModalBody>
                                <ModalFooter>
                                    <Button type= "submit" size="sm" color="primary" className="submit-button">OK</Button>
                                </ModalFooter>
                            </Form>
                        </Modal>
                    </div>
                </div>
            </div>
        );
    }
}

Signup.propTypes = {
    createAccount: Proptypes.func.isRequired,
    fields: Proptypes.array,
    handleSubmit: Proptypes.func,
    isLoggedIn: Proptypes.bool,
    has2fa: Proptypes.bool,
    new_two_factor: Proptypes.bool,
    user_info: Proptypes.object,
    signupError: Proptypes.string,
    history: Proptypes.object,
    initialize: Proptypes.func,
};

Signup = withRouter(Signup);

function mapStateToProps(state) {
    return {
        isLoading: state.createAccount.createAccountLoading,
        createAccountError: state.createAccount.createAccountError,
        createAccountSuccess: state.createAccount.createAccountSuccess,
        login_settings: state.auth.login_settings,
        sso_url: state.saml.sso_url,
        sso_error: state.saml.sso_error,
        sso_saml_error: state.saml.sso_saml_error,
        saml_configs: _.get(state.auth.login_settings, "saml.saml_configs", []),
        oidc_configs: _.get(state.auth.login_settings, "oidc.oidc_configs", []),
        getSsoLoading: state.auth.getSsoLoading || false,
    };
}

function mapDispatchToProps(dispatch) {
    return ({
        createAccount: (login_data) => dispatch(createAccount(login_data)),
        getLoginSettings: () => dispatch(getLoginSettings()),
        getsso: (ssoType, id) => dispatch(getSignOnURL(ssoType, id))
    });
}

let SignupWithRouter =  withRouter(Signup);

let SignupComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(SignupWithRouter);

export default reduxForm({
    form: "SignupPageForm",
    fields: ["username", "password"]
})(SignupComponent);